export const getScrollY = (element: HTMLElement | (Window & typeof globalThis)) => {
    if (element instanceof HTMLElement) {
        return element.scrollTop;
    }

    return element.pageYOffset;
};
